import React, { Fragment, useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useLazyGetProfileQuery, useAuthExchangeMutation } from 'features/auth/authApi';
import { setSalesforceBaseUrl } from 'features/auth/authSlice';
import Error from 'components/Error/Error';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { setUserInfo } from 'features/auth/authSlice';
import { CircularProgress } from '@mui/material';
import styles from './AuthSalesforceCanvas.module.css';
import { setIsSalesforceAuth, setSalesforceId } from 'features/salesforce/salesforceSlice';

const AuthSalesforceCanvas = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const useSelector = useAppSelector;
  const authUser = useSelector(state => state.auth.user);
  const queryParams = new URLSearchParams(location.search);
  const canvasToken = queryParams.get('token');
  const salesforceBaseUrl = queryParams.get('salesforceBaseUrl');
  const [authExchange, { data, error }] = useAuthExchangeMutation();
  const [fetchData, { data: dataProfile }] = useLazyGetProfileQuery();

  const isSalesforceAuth = dataProfile?.data.authType === 'salesforce';

  React.useEffect(() => {
    if (salesforceBaseUrl) {
      localStorage.setItem('salesforceBaseUrl', salesforceBaseUrl);
    }
    const localStorageSalesforceBaseUrl = localStorage.getItem('salesforceBaseUrl');
    if (localStorageSalesforceBaseUrl) {
      dispatch(setSalesforceBaseUrl({ salesforceBaseUrl: localStorageSalesforceBaseUrl }));
    }

    if (canvasToken) {
      authExchange(canvasToken);
    } else if (!canvasToken && !authUser) {
      fetchData('profile');
    }
  }, [canvasToken, salesforceBaseUrl, authExchange]);

  useEffect(() => {
    dispatch(setIsSalesforceAuth(isSalesforceAuth));
    if (dataProfile && dataProfile.data) {
      const { id, name, email, role } = dataProfile.data;
      dispatch(setUserInfo({ user: { id, email, name, role } }));
      dispatch(setSalesforceId(dataProfile.data.salesforceId));
    }
  }, [dataProfile]);

  if (!canvasToken) {
    return <Outlet />;
  }
  const renderCanvas = () => {
    if (!data && !error) {
      return (
        <div className={styles.container}>
          <CircularProgress />
        </div>
      );
    }
    return <Error />;
  };

  if (data?.accessToken && canvasToken) {
    navigate('/', { replace: true });
  }

  return <Fragment>{renderCanvas()}</Fragment>;
};

export default AuthSalesforceCanvas;
